import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad4c5ac8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BasicForm" }
const _hoisted_2 = { class: "handle-btns" }

import BaseForm from '@/components/BaseForm.vue'
import { useRouter } from 'vue-router'
import {
  ref,
  watch,
  withDefaults
} from 'vue'
import { IFormArr } from '@/components/types'
import { useStore } from '@/store'
import { createPageData, editPageData } from '@/service/main/system'
import { ElMessageBox } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicForm',
  props: {
    basicFormConfig: {},
    defaultInfo: { default: {} },
    pageName: {},
    title: {},
    url: {},
    otherInfo: { default: {} },
    watchDeep: { type: Boolean },
    valid: { type: Boolean, default: false },
    validOtherInfo: { type: Function, default: (data: any) => true },
    getFilesMap: { default: {} },
    colLayout: { default: () => ({
      xl: 8,
      lg: 8,
      md: 8,
      sm: 8,
      xs: 8
    }) },
    checkInfo: {}
  },
  emits: ["cancelBtnClick", "submitBtnClick", "verifyBtnClick", "closePage"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const isBatch = ref(false)
const props = __props

const emit = __emit

const router = useRouter()
const handleCancelClick = () => {
  emit('closePage')
  router.back()
}
const handleVerifyClick = () => {
  emit('verifyBtnClick')
}

const formData = ref<any>({})

watch(
  () => props.defaultInfo,
  (newValue) => {
    formData.value['isDisabled'] =
      newValue['verifyResult'] == '1' ||
      newValue['applyStatus'] == '1' ||
      newValue['raffleStatus'] == '1'
    for (const items of props.basicFormConfig.iForms) {
      for (const item of items.formItems) {
        formData.value[`${item.field}`] = newValue[`${item.field}`]
      }
    }
  },
  { deep: props.watchDeep, immediate: true }
)

const confirmLoading = ref(false)
const baseFormRef = ref<InstanceType<typeof BaseForm>>()
const store = useStore()
const handleSubmitClick = async () => {
  if (props.checkInfo) {
    ElMessageBox.confirm(props.checkInfo, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'success',
      center: true
    }).then(async () => {
      doSubmit()
    })
  } else {
    doSubmit()
  }
}

const doSubmit = async () => {
  // confirmLoading.value = true
  // baseFormRef.value?.validate(async (isValid) => {
  let parentValid = await props.validOtherInfo({ ...formData.value })
  if (props.valid && !parentValid) {
    return
  }
  // if (isValid && parentValid) {
  // if (isBatch.value) {
  //   emit('updateBatchData', { ...formData.value })
  // } else {
  if (
    Object.keys(props.defaultInfo).length &&
    Object.keys(props.defaultInfo).indexOf('isCreate') < 0
  ) {
    // 编辑
    let pageUrl = `/main/${props.pageName}/${props.defaultInfo.id}`
    if (props.url) {
      pageUrl = props.url
    }
    try {
      await editPageData(pageUrl, {
        ...formData.value,
        ...props.otherInfo
      })
      if (store.state.system.queryInfo.value != undefined) {
        store.dispatch('system/getPageListAction', {
          pageName: props.pageName,
          queryInfo: store.state.system.queryInfo
        })
      }
      emit('closePage')
      //dialogVisible.value = false
    } finally {
      // confirmLoading.value = false
    }
  } else {
    // 新建
    const pageUrl = `/main/${props.pageName}/submit`
    try {
      await createPageData(pageUrl, {
        ...formData.value,
        ...props.otherInfo
      })
      if (store.state.system.queryInfo.value != undefined) {
        store.dispatch('system/getPageListAction', {
          pageName: props.pageName,
          queryInfo: store.state.system.queryInfo
        })
      }
      emit('closePage')
      // dialogVisible.value = false
    } finally {
      // confirmLoading.value = false
    }
  }
  router.back()
  // }
  // } else {
  //   confirmLoading.value = false
  // }
  //}//)
}
const getFormData = () => {
  return formData
}

__expose({
  getFormData
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseForm, _mergeProps(_ctx.basicFormConfig, {
      colLayout: _ctx.colLayout,
      modelValue: formData.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData).value = $event)),
      ref_key: "baseFormRef",
      ref: baseFormRef
    }), {
      insert: _withCtx(() => [
        _renderSlot(_ctx.$slots, "insert")
      ]),
      proveInsert: _withCtx(() => [
        _renderSlot(_ctx.$slots, "proveInsert")
      ]),
      fileInsert: _withCtx(() => [
        _renderSlot(_ctx.$slots, "fileInsert")
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _renderSlot(_ctx.$slots, "bottom")
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_button, { onClick: handleCancelClick }, {
            default: _withCtx(() => [
              _createTextVNode(" 取消 ")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleSubmitClick,
            loading: confirmLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 提交 ")
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_ctx.colLayout)), {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "header")
          ]),
          _: 3
        }, 16)
      ]),
      _: 3
    }, 16, ["colLayout", "modelValue"])
  ]))
}
}

})